module.exports = __webpack_public_path__ + "static/media/cookie1.c81f8d25.png";